import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftDoorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearLeftDoor(props: RearLeftDoorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Left Door"
      width={318}
      height={92}
      viewBox="0 0 318 92"
      position={{bottom: -5, right: 321}}
    >
      {/* Door body (evenodd composite) */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97 1C126 1 193.063 5.47911 233 17C278.063 29.9999 317 38.8893 317 57C317 75 284 86 257 86H2C3.33333 82.8867 7 74.6235 11 67.6953C15 60.7671 15.3333 54.8086 15 52.6953L34 1H97ZM46.0771 7L39 53L200.915 52.415L206.046 17.7803C156.985 8.57626 104.673 7.00151 46.084 7H46.0771ZM206.928 52.3936L287 52.1045C287 43.1046 281.967 39.0966 261 32C244.957 26.5702 228.671 22.298 212.021 18.9424L206.928 52.3936Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Vent glass overlay */}
      <path
        opacity="0.8"
        d="M206.927 52.3938L212.02 18.942C228.671 22.2977 244.957 26.5701 261 32C281.968 39.0967 287 43.1047 287 52.1047L206.927 52.3938Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Door glass overlay */}
      <path
        opacity="0.8"
        d="M200.915 52.4155L206.045 17.7798C156.984 8.57583 104.673 7.00151 46.0844 7H46.0769L39 53L200.915 52.4155Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Outer stroke */}
      <path
        d="M233 17C193.063 5.47911 126 1 97 1L53 1L34 1L15 52.6953C15.3333 54.8086 15 60.7671 11 67.6953C7 74.6235 3.33333 82.8867 2 86H257C284 86 317 75 317 57C317 38.8893 278.063 29.9999 233 17Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Pillar line */}
      <path
        d="M39 53L47 1"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Waist line */}
      <path
        d="M316 52L39 53H15"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Glass inner line */}
      <path
        d="M287 52C287 43 281.968 39.0967 261 32C196 10 127 7 46 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Vent pillar */}
      <path
        d="M212 19L207 52"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M206 18L201 52"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Belt line */}
      <path
        d="M13 64.3913C120.201 63.1958 226.843 63.7192 316 62.3044"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Door handle fill */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224 76C238.937 76.0003 258.853 78 256.861 81C250.119 91.1562 231.966 91 224 91C216.034 91 197.881 91.1562 191.139 81C189.147 78 209.062 76.0003 224 76ZM207 82C208.766 84.2432 211.491 86 216 86H232C236.509 86 239.234 84.2432 241 82H207Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Handle outline */}
      <path
        d="M256.862 81C250.119 91.1563 231.966 90.9999 224 90.9999C216.034 90.9999 197.881 91.1563 191.138 81C189.147 78 209.062 76.0003 224 76C238.937 76.0003 258.853 78 256.862 81Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Handle inner */}
      <path
        d="M243 77C242.667 79.6667 240 86 232 86C224 86 224 86 224 86C224 86 224 86 216 86C208 86 205.333 79.6667 205 77"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M207 82H241"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
